export const CookieSafeEncode = (string_value) => {
    if (!string_value || typeof string_value !== 'string') return '';

    return string_value.replace(/=/g,'U+003D')
                .replace(/&/g,'U+0026');
};

export const CookieSafeDecode = (string_value) => {
    if (!string_value || typeof string_value !== 'string') return '';

    return string_value.replace(/U\+003D/g,'=')
                .replace(/U\+0026/g,'&');
}
export const getCookieDomain = () => {
    const host = (window.location && window.location.hostname) || '';
    if (host === 'shipbob.com' || host.endsWith('.shipbob.com')) {
        return '.shipbob.com';
    }
    return '';
};

export const DeleteCookie = (name) => {
    if (!name) return null;

    const expired = 'Thu, 01 Jan 1970 00:00:01 GMT';
    const domain = getCookieDomain();

    document.cookie = `${name}=; path=/; expires=${expired}`;
    document.cookie = `${name}=; expires=${expired}`;
    if (domain) {
        document.cookie = `${name}=; path=/; domain=${domain}; expires=${expired}`;
    }
};

export const SetCookie = (name, value) => {
    if (!name) return null;

    const expiration_date = new Date();
    expiration_date.setFullYear(expiration_date.getFullYear() + 1);

    const domain = getCookieDomain();
    const domainAttr = domain ? `; domain=${domain}` : '';

    if (domain) {
        // Evict any legacy host-only cookie that would shadow the new
        // domain-scoped one (host-only beats domain-scoped on read order).
        document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT`;
    }

    return document.cookie = `${name}=${CookieSafeEncode(value)}; path=/${domainAttr}; expires=${expiration_date}`;
};

export const GetCookies = () => {
    const cookies = window.document.cookie.split(';');
    const cookie_array = cookies.map(function(key_pair) {
      var split = key_pair.split('=');
      var key = split[0].replace(' ','');
      var pair = split[1];
      
      return [key, CookieSafeDecode(pair)]; 
    });
    
    const cookie_obj = cookie_array.reduce(function(acc, current) {
      var key = current[0];
      var pair = current[1];
      acc[key] = pair;
      
      return acc;
    }, {});
    
    return cookie_obj; 
}